import React, { useEffect } from 'react';
import { sendMobileLoadedNotification, setViewMeta } from '@ecs-uk/web-common-mobile-view-helpers';
import ChangeBillingDatePage from '../../change-billing-date';

const MobileChangeBillingDatePage = () => {
  useEffect(() => {
    setViewMeta({ viewTitle: 'Change billing date' });
    sendMobileLoadedNotification();
  }, []);

  return <ChangeBillingDatePage isWebview />;
};

export default MobileChangeBillingDatePage;
